// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3YVZt","emails":"CreateEditClinics_emails__3d9dM","emailTagLabel":"CreateEditClinics_emailTagLabel__36_gS"};